// extracted by mini-css-extract-plugin
export var countdown = "PageDataBodyCountdown-module--countdown--PildY";
export var days = "PageDataBodyCountdown-module--days--0wcuO";
export var donut = "PageDataBodyCountdown-module--donut--dHQXL";
export var donutContainer = "PageDataBodyCountdown-module--donutContainer---RBMP";
export var finished = "PageDataBodyCountdown-module--finished--udnSD";
export var hours = "PageDataBodyCountdown-module--hours--+B9+6";
export var minutes = "PageDataBodyCountdown-module--minutes--zuQwZ";
export var months = "PageDataBodyCountdown-module--months---Gddq";
export var seconds = "PageDataBodyCountdown-module--seconds--w-5sR";